export type SearchDocument = {
	path: string;
	title: string;
	description: string;
	sections: { title: string; paragraphs: string[] }[];
	related: { path: string; label: string }[];
	kind: 'service' | 'guide';
	sources?: { url: string; label: string }[];
};
export const SEARCH_DOCUMENTS: SearchDocument[] = [
	{
		path: '/services/app-development',
		kind: 'service',
		title: 'iOS·Android 모바일 앱 개발',
		description:
			'iOS·Android 앱 개발을 준비할 때 필요한 사용자 흐름, 관리자 기능, 외부 연동과 출시 범위를 실제 앱 사례와 함께 확인하세요.',
		sections: [
			{
				title: '앱의 화면보다 먼저 사용자와 운영 흐름을 정합니다',
				paragraphs: [
					'모바일 앱은 사용자가 서비스를 이용하는 화면과 운영자가 처리하는 업무가 함께 돌아가야 합니다. 회원가입에서 예약·결제·알림으로 이어지는 흐름, 예외 상황에서의 취소와 문의, 운영자의 처리 권한을 함께 정리합니다.',
					'미스터디벨로는 서비스 기획, UI·UX 디자인, 프론트엔드, 백엔드와 QA 범위를 상담 후 정합니다. 이미 기획서나 디자인이 있다면 검토 후 필요한 부분만 개발하는 방식도 협의할 수 있습니다.'
				]
			},
			{
				title: '견적을 나누는 기준',
				paragraphs: [
					'iOS·Android 지원 범위, 사용자 역할 수, 관리자 화면, 결제·지도·인증 등 외부 연동, 데이터 이전, 접근성 요구와 운영 환경이 작업 범위에 영향을 줍니다. 같은 화면 수라도 권한과 연동 복잡도에 따라 비용과 일정이 달라집니다.',
					'출시 전에 스토어 계정의 소유자, 심사 자료, 개인정보 처리방침, 테스트 계정, 운영 서버와 외부 서비스 요금의 부담 주체를 확인하는 것이 좋습니다. 비용과 확정 일정은 요구사항 검토와 계약 범위에 따라 안내합니다.'
				]
			},
			{
				title: '실제 사례에서 확인할 점',
				paragraphs: [
					'파라다이스호텔 부산 사례는 모바일 체크인·체크아웃, 모바일 키와 예약·멤버십 흐름을 다룹니다. 반려시대 사례는 반려견 유치원 탐색·예약과 운영 관리의 연결을 보여줍니다.',
					'사례 페이지에서 고객명, 진행 기간과 미스터디벨로의 참여 범위를 확인할 수 있습니다. 특정 고객의 서비스 기능이 모든 신규 프로젝트의 기본 제공 항목이라는 뜻은 아닙니다.'
				]
			}
		],
		related: [
			{
				path: '/portfolio/paradise-busan',
				label: '파라다이스호텔 부산 앱 사례'
			},
			{ path: '/portfolio/pet-era', label: '반려시대 CRM 사례' },
			{
				path: '/guides/development-estimate',
				label: '개발 견적 비교 체크리스트'
			}
		]
	},
	{
		path: '/services/web-platform',
		kind: 'service',
		title: '웹 서비스·플랫폼 개발',
		description:
			'고객 화면과 관리자 업무, 권한·데이터·외부 시스템 연동을 함께 설계하는 웹 서비스와 플랫폼 개발 안내.',
		sections: [
			{
				title: '플랫폼의 핵심은 역할과 데이터의 연결입니다',
				paragraphs: [
					'예약·거래·교육·사내 콘텐츠 서비스는 사용자와 운영자의 역할이 다릅니다. 누가 어떤 정보를 등록하고 승인하며 조회하는지, 오류나 취소 시 어떤 상태로 돌아가야 하는지를 정의하면 화면 뒤의 업무를 구체화할 수 있습니다.',
					'기획부터 전체 개발을 맡기는 턴키 방식뿐 아니라 기존 팀과 역할을 나누는 프론트엔드·백엔드 참여도 협의합니다. 공개 사례의 서비스 전체 기능과 실제 참여 범위를 구분해 안내합니다.'
				]
			},
			{
				title: '착수 전에 정리하면 좋은 정보',
				paragraphs: [
					'사용자 유형과 관리자 권한, 기존 데이터의 형식·규모, 외부 API 문서와 사용 권한, 결제·정산 방식, 예상 접속 패턴과 장애 대응 기준을 정리해 주세요.',
					'공개 콘텐츠가 검색 유입을 받아야 한다면 URL 구조와 초기 HTML, 제목·설명·사이트맵을 화면 설계 때 함께 검토해야 합니다. 로그인이 필요한 정보와 공개 정보의 경계도 이 단계에서 정합니다.'
				]
			},
			{
				title: '서로 다른 참여 형태의 사례',
				paragraphs: [
					'디어먼데이는 워케이션 공간을 살펴보고 예약하는 웹 서비스의 턴키 사례입니다. 현대자동차그룹 리더십 플랫폼은 다국어 메시지와 트랜스크립트를 제공하는 서비스의 프론트엔드 참여 사례입니다.',
					'같은 플랫폼 개발이라도 데이터 이전, 관리자 기능, 운영 지원 범위가 다를 수 있습니다. 문의 시 현재 시스템 유무와 공개 가능한 요구사항을 알려주시면 범위를 구체적으로 검토할 수 있습니다.'
				]
			}
		],
		related: [
			{
				path: '/portfolio/dear-monday',
				label: '디어먼데이 웹 서비스 사례'
			},
			{
				path: '/portfolio/hyundai',
				label: '현대 HMG 프론트엔드 참여 사례'
			},
			{
				path: '/portfolio/link-school',
				label: '링스쿨 디지털 교육 플랫폼 사례'
			}
		]
	},
	{
		path: '/services/mvp-development',
		kind: 'service',
		title: '스타트업 MVP 기획·개발',
		description:
			'처음 출시할 핵심 기능을 정하고 사용자 반응을 확인하기 위한 MVP 기획·개발의 범위와 의사결정 기준.',
		sections: [
			{
				title: 'MVP는 첫 출시에서 확인할 질문을 정하는 일입니다',
				paragraphs: [
					'첫 버전의 목적이 고객 수요 확인인지, 투자·제휴 시연인지, 유료 서비스의 운영 시작인지에 따라 필요한 완성도가 달라집니다. 핵심 사용자가 수행해야 할 행동과 결과를 먼저 정하고, 그 검증에 직접 필요한 기능을 우선합니다.',
					'기획서가 완성되지 않았더라도 서비스가 필요한 이유, 사용 대상, 현재의 대체 수단과 중요한 제약을 알려주세요. 구현할 기능뿐 아니라 첫 버전에서 제외할 범위도 함께 정리합니다.'
				]
			},
			{
				title: '기간과 예산을 판단하는 방법',
				paragraphs: [
					'로그인·결제·실시간 통신·외부 API 같은 공통 기능도 적용 방식에 따라 작업량이 달라집니다. 운영자가 수동으로 처리할 수 있는 업무와 자동화가 꼭 필요한 업무를 나누면 우선순위를 정하기 쉽습니다.',
					'FAQ의 기간 안내는 일반적인 예시입니다. 확정 일정은 기능 범위, 자료 준비, 연동 의존성과 검수 일정을 검토한 뒤 정하며, MVP라는 명칭만으로 일률적인 비용이나 납기를 보장하지 않습니다.'
				]
			},
			{
				title: '첫 출시 이후를 위한 준비',
				paragraphs: [
					'핵심 행동의 완료율, 실제 사용자의 피드백과 문의 기록처럼 다음 결정을 돕는 측정 기준을 정합니다. 조회 수만으로 기능의 효과를 판단하기보다 서비스 목표와 연결된 행동을 확인하는 편이 유용합니다.',
					'기능 확장은 검증 결과와 운영 부담을 함께 보고 결정합니다. 코드·계정·데이터의 인수인계 범위와 개선 요청의 처리 방식도 초기 계약에서 합의해 두면 다음 단계로 이어가기 쉽습니다.'
				]
			}
		],
		related: [
			{
				path: '/guides/project-brief',
				label: '기획서가 없을 때 준비할 질문'
			},
			{
				path: '/guides/development-estimate',
				label: '견적·추가 비용을 비교하는 방법'
			},
			{ path: '/intro/process', label: '상담부터 검수까지의 과정' }
		]
	},
	{
		path: '/services/maintenance',
		kind: 'service',
		title: '서비스 유지보수·고도화',
		description:
			'출시 후 오류 수정, 기능 개선, 외부 API·운영체제 대응과 인수인계를 구분해 준비하는 유지보수 안내.',
		sections: [
			{
				title: '오류 수정과 기능 추가의 범위를 구분합니다',
				paragraphs: [
					'합의한 기능이 정상 동작하지 않는 오류 수정과 새로운 기능·정책을 추가하는 고도화는 필요한 검토와 작업량이 다릅니다. OS·브라우저·외부 API 변경에 따른 대응도 별도 범위가 될 수 있습니다.',
					'계약 시 무상 지원 대상과 기간, 유상 변경 기준, 요청 접수 방식과 긴급도를 정합니다. 공개된 유지보수 예시보다 개별 계약의 확정 범위와 조건이 우선합니다.'
				]
			},
			{
				title: '기존 서비스를 넘길 때 필요한 자료',
				paragraphs: [
					'소스 저장소, 실행·배포 방법, 서비스 계정 소유권, 데이터베이스 구조, 외부 연동 문서와 현재 장애 기록을 정리하면 인수 검토에 도움이 됩니다. 비밀번호나 민감한 개인정보를 문의 폼에 입력하지 말고 적절한 공유 방식부터 협의해 주세요.',
					'현재 코드와 운영 환경을 확인하기 전에 수정 가능 여부나 처리 기간을 단정하기는 어렵습니다. 우선 현황과 재현 조건을 확인한 뒤 작업 범위와 우선순위를 정합니다.'
				]
			},
			{
				title: '운영 중 변경을 검증하는 기준',
				paragraphs: [
					'문제가 발생한 화면·시점·기기와 재현 절차를 기록하고, 수정 후 확인할 정상 동작을 명확히 합니다. 결제·알림·권한처럼 다른 기능에 영향을 주는 변경은 회귀 확인 범위를 함께 정합니다.',
					'운영 비용, 로그·모니터링, 백업·복구와 장애 연락 체계도 서비스의 특성에 맞춰 합의합니다. 응답 시간과 해결 시간은 구분하고, 외부 서비스에 의존하는 문제는 그 조건을 함께 확인합니다.'
				]
			}
		],
		related: [
			{ path: '/faq', label: '유지보수 관련 FAQ' },
			{ path: '/intro/process', label: '개발·검수·운영 전환 과정' },
			{ path: '/inquiry', label: '현재 서비스 상담하기' }
		]
	},
	{
		path: '/guides/development-estimate',
		kind: 'guide',
		title: '앱·웹 개발 견적 비교 체크리스트',
		description:
			'개발 견적의 포함 범위, 추가 비용, 검수 기준과 운영 비용을 같은 조건에서 비교하는 방법.',
		sections: [
			{
				title: '총액을 비교하기 전에 포함 범위를 맞춥니다',
				paragraphs: [
					'기획, 디자인, 퍼블리싱, 프론트엔드, 백엔드, 관리자, QA와 출시 지원 중 어떤 항목이 포함되는지 표로 정리하세요. 고객용 화면만 있고 관리자가 처리할 업무가 빠져 있으면 이후 비용과 일정에 영향을 줄 수 있습니다.',
					'화면 수 외에도 사용자 권한, 예외 처리, 결제 취소·환불, 외부 연동과 데이터 이전을 확인하세요. 요구사항과 산출물을 같은 수준으로 정리해야 업체별 견적 차이를 해석할 수 있습니다.'
				]
			},
			{
				title: '추가 비용이 발생하는 조건을 질문합니다',
				paragraphs: [
					'“이 금액에 어디까지 포함되고, 추가 비용은 언제 발생하나요?”라는 질문을 기능별로 구체화하세요. 확정 이후 요구 변경, 외부 API 변경, 자료 지연, 디자인 수정 횟수와 추가 기기 지원의 처리 방식을 확인합니다.',
					'서버·도메인·유료 API·문자·결제 수수료 등 운영 비용의 지불 주체도 확인하세요. 개발비에 포함되지 않는 비용은 별도로 목록화해야 실제 운영 예산을 계산할 수 있습니다.'
				]
			},
			{
				title: '검수와 인수인계를 계약에 연결합니다',
				paragraphs: [
					'완료의 기준을 화면별·기능별로 적고 누가 언제 검수할지 정하세요. 소스 코드, 디자인 원본, 계정, 배포 문서와 데이터의 인수 범위도 확인합니다.',
					'주간 보고와 문제 해결 창구, 지연·변경 시 협의 절차, 출시 후 오류 수정 범위를 문서로 남기는 것이 좋습니다. 이 글은 비교를 돕는 실무 질문이며 특정 계약의 조건을 대신하지 않습니다.'
				]
			}
		],
		related: [
			{ path: '/faq', label: '비용·기간·계약 FAQ' },
			{ path: '/intro/turn-key', label: '턴키 개발의 범위' },
			{ path: '/services/maintenance', label: '출시 후 유지보수 범위' }
		]
	},
	{
		path: '/guides/project-brief',
		kind: 'guide',
		title: '기획서가 없을 때 개발 상담 준비 방법',
		description:
			'만들고 싶은 이유부터 대상 사용자, 핵심 행동, 참고 서비스와 제약 조건까지 정리하는 개발 상담 준비 가이드.',
		sections: [
			{
				title: '만들고 싶은 기능보다 해결할 문제를 설명합니다',
				paragraphs: [
					'누가 어떤 상황에서 불편을 겪고 있는지, 지금은 어떤 방법으로 해결하는지, 새 서비스가 생기면 무엇이 달라져야 하는지 적어보세요. 사용자와 운영자의 관점이 다르다면 각각 정리하면 좋습니다.',
					'완성된 기획서가 없어도 상담을 시작할 수 있습니다. 다만 아이디어가 실제 개발 범위가 되기까지는 사용자 흐름, 정보 구조, 예외 상황과 기술적 의존성을 구체화하는 과정이 필요합니다.'
				]
			},
			{
				title: '첫 상담에 도움이 되는 다섯 가지',
				paragraphs: [
					'1. 가장 중요한 사용자와 해결할 문제. 2. 첫 버전에서 꼭 완료되어야 하는 행동. 3. 참고 서비스와 참고하려는 이유. 4. 예산·출시 희망일과 그 배경. 5. 이미 가진 디자인·데이터·시스템·팀의 현황을 준비해 주세요.',
					'참고 화면은 그대로 복제할 요구사항이 아니라 원하는 경험을 설명하는 자료로 사용하세요. 반드시 필요한 기능과 이후로 미뤄도 되는 기능을 구분하면 현실적인 첫 범위를 논의하기 쉽습니다.'
				]
			},
			{
				title: '상담 이후에는 확인 가능한 문서로 정리합니다',
				paragraphs: [
					'기능 이름만 나열하기보다 사용자 입력, 시스템 처리, 결과 화면과 실패 시 동작을 정리합니다. 외부 API의 제공 범위와 권한, 개인정보 처리와 운영자의 업무도 함께 확인합니다.',
					'검토 결과와 미정 사항을 구분하고, 결정이 필요한 항목의 담당자와 시점을 정하세요. 미스터디벨로의 공개 프로세스와 실제 사례에서 참여 방식과 산출물의 맥락을 확인할 수 있습니다.'
				]
			}
		],
		related: [
			{ path: '/services/mvp-development', label: 'MVP 범위 정하기' },
			{ path: '/intro/process', label: '개발 진행 과정' },
			{ path: '/inquiry', label: '서비스 상담하기' }
		]
	},
	{
		path: '/services/si-development',
		kind: 'service',
		title: '서울 SI 개발 · 기업 시스템 구축',
		description:
			'서울 마포구의 미스터디벨로가 기업의 웹·앱과 업무 시스템 개발 범위, 기존 시스템 연동, 발주·검수 기준을 안내합니다. 실제 기업 프로젝트의 참여 범위를 확인하세요.',
		sections: [
			{
				title: '기업 SI 개발은 어떤 업무를 바꾸는지부터 정합니다',
				paragraphs: [
					'SI(System Integration)는 기업의 업무와 여러 시스템을 연결하는 개발을 가리킵니다. 고객용 앱·웹뿐 아니라 관리자 승인, 구성원 권한, 데이터 이동과 기존 시스템 연동이 프로젝트의 핵심 범위가 될 수 있습니다.',
					'미스터디벨로는 서울 마포구에 있는 앱·웹 개발사로, 기획·디자인·개발·QA의 참여 범위를 프로젝트에 맞춰 협의합니다. 중소·중견기업과 대기업 담당자는 필요한 역할, 내부 개발팀의 현황과 보안·구매 절차를 함께 알려주세요.'
				]
			},
			{
				title: '기존 시스템 연동이 필요한 경우 무엇을 준비하나요?',
				paragraphs: [
					'현재 시스템 구성도, 연동 대상 API와 권한, 데이터 항목, 사용자별 접근 범위와 정상·오류 시나리오를 준비하면 범위 검토가 구체적이 됩니다. 실제 운영 데이터나 접근 비밀번호 대신 공개 가능한 설명과 샘플 구조부터 공유해 주세요.',
					'인증·권한, 테스트 환경, 배포 승인과 운영 전환의 담당자를 정해야 합니다. SSO·ERP·CRM 등의 연동 가능 여부는 제품명만으로 확정하지 않고 API 제공 조건과 현재 환경을 확인한 뒤 판단합니다.'
				]
			},
			{
				title: '기업 사례는 고객명과 실제 참여 범위를 함께 보세요',
				paragraphs: [
					'현대자동차그룹 리더십 플랫폼 사례에는 현대오토에버 발주와 프론트엔드 참여 범위가 공개되어 있습니다. 파라다이스호텔 부산 사례는 앱의 체크인·체크아웃과 모바일 키 등 호텔 서비스 흐름을 소개합니다.',
					'기존 사례가 모든 기업의 보안 인증이나 납품 자격을 대신하지는 않습니다. 제안 요청 시 필수 인증, 계약 주체, 재위탁 조건, 산출물 소유권과 운영 지원 요구를 알려주시면 수행 범위를 검토할 수 있습니다.'
				]
			},
			{
				title: '기업 담당자가 비교할 납품 기준',
				paragraphs: [
					'요구사항별 담당 범위, 인터페이스 명세, 테스트 결과, 운영·배포 문서와 소스 인계를 계약 산출물에 연결하세요. 기존 시스템을 교체한다면 데이터 검증, 전환 일정과 복구 절차도 함께 정하는 것이 좋습니다.'
				]
			}
		],
		related: [
			{
				path: '/portfolio/hyundai',
				label: '현대 HMG 프론트엔드 참여 사례'
			},
			{
				path: '/portfolio/paradise-busan',
				label: '파라다이스호텔 부산 앱 사례'
			},
			{
				path: '/guides/enterprise-development-rfp',
				label: '기업 개발 발주·RFP 체크리스트'
			}
		]
	},
	{
		path: '/guides/government-funded-development',
		kind: 'guide',
		title: '정부지원사업 앱·웹 개발 외주 준비 가이드',
		description:
			'청년창업사관학교·예비창업패키지·초기창업패키지 등 지원사업으로 앱·웹·MVP 개발을 준비할 때 확인할 범위, 일정, 견적·검수 자료와 공식 공고 확인 방법.',
		sections: [
			{
				title: '정부지원사업으로 앱·웹 개발사를 찾고 있나요?',
				paragraphs: [
					'청년창업사관학교(청창사), 예비창업패키지, 초기창업패키지, 창업도약패키지 등으로 서비스를 준비한다면 개발 목표와 사업의 협약 조건을 함께 검토해야 합니다. 같은 앱 개발이라도 제출할 산출물과 완료 시점이 다르면 범위가 달라집니다.',
					'미스터디벨로에는 앱·웹·MVP의 기능 범위와 개발 일정에 대해 상담할 수 있습니다. 사업명과 연도, 적용 공고·지침, 협약 종료일, 현재 기획 상태와 필요한 결과물을 알려주세요. 사업비 집행 가능 여부와 공급업체 요건은 해당 사업의 운영기관에 먼저 확인해야 합니다.'
				]
			},
			{
				title: '청년창업사관학교 입교 전후에는 무엇을 확인하나요?',
				paragraphs: [
					'중소벤처기업진흥공단의 청년창업사관학교는 창업 과정과 사업화를 지원하는 사업입니다. 최신 모집 공고와 입교 후 적용되는 협약·사업비 안내를 확인하고, 외주 개발의 허용 범위와 필요한 절차를 담당자에게 질문하세요.',
					'선정 전 준비용 화면, 평가 시연용 MVP와 실제 고객이 이용하는 출시 서비스는 목표가 다릅니다. 검증하려는 사용자 행동, 시연할 핵심 흐름과 검수 가능한 기능을 구분해 과업 범위를 정하면 상담에 도움이 됩니다.'
				]
			},
			{
				title: '개발 계약 전에 운영기관에 확인할 질문',
				paragraphs: [
					'외주 개발비로 집행 가능한 항목은 무엇인지, 사전 승인이나 업체 선정 절차가 있는지, 견적 비교·계약·검수 자료는 어떤 양식으로 제출하는지 확인하세요. 자부담·부가세 처리, 지급 시점과 협약 종료 전 완료 기준도 해당 기관의 답변을 받아 정리하는 것이 좋습니다.',
					'예비·초기·도약 등 사업명만 보고 조건을 동일하게 적용하면 안 됩니다. K-Startup에는 통합관리지침 개정 안내가 공개되어 있으며 개별 공고·세부기준·협약에 따라 적용 사항을 확인해야 합니다. 이 안내는 선정, 사업비 인정이나 정산 승인을 보장하지 않습니다.'
				]
			},
			{
				title: '견적·과업·검수가 같은 기능을 가리키게 만드세요',
				paragraphs: [
					'견적서에는 참여 단계와 포함·제외 범위를, 과업 문서에는 사용자 행동과 결과물을, 검수 기준에는 완료를 확인할 방법을 적습니다. 운영기관이 요구하는 서류와 개발사의 제공 가능한 산출물을 착수 전에 맞춰야 합니다.',
					'예를 들어 예약 MVP라면 검색·예약 요청·관리자 승인·결과 알림의 범위를 정하고, 실제 결제와 환불까지 포함하는지 따로 확인합니다. 평가를 위한 시연 화면과 운영에 필요한 예외 처리·보안·데이터 관리의 차이도 표시해 주세요.'
				]
			},
			{
				title: '마감일에서 역산할 때 빠뜨리기 쉬운 시간',
				paragraphs: [
					'기능 개발 외에 자료 제공, 외부 API 승인, 스토어 심사, 테스트, 고객 검수와 수정 시간이 필요합니다. 정해진 마감이 있다면 필수 기능과 후속 기능을 나누고, 변경 요청이 일정에 미치는 영향도 함께 검토하세요.',
					'상담 시 사업명·적용 연도, 공식 공고 링크, 종료일, 핵심 사용자, 필요한 앱·웹·관리자, 검수 담당자와 공개 가능한 요구사항을 준비하면 좋습니다. 지원사업 선정이나 납기를 개발사 추천만으로 판단하지 마세요.'
				]
			}
		],
		related: [
			{
				path: '/services/mvp-development',
				label: 'MVP 기획·개발 범위'
			},
			{
				path: '/guides/development-estimate',
				label: '개발 견적 비교 체크리스트'
			},
			{
				path: '/guides/project-brief',
				label: '첫 개발 상담 준비 방법'
			},
			{
				path: '/inquiry',
				label: '지원사업 개발 범위 상담'
			}
		],
		sources: [
			{
				url: 'https://start.kosmes.or.kr/',
				label: '중소벤처기업진흥공단 청년창업사관학교 공식 사이트·공고'
			},
			{
				url: 'https://www.k-startup.go.kr/user/board/webRFRR_view_reference.do?id=172153&schM=view',
				label: 'K-Startup 중소기업창업 지원사업 통합관리지침 제14차 개정 안내'
			},
			{
				url: 'https://www.kised.or.kr/menu.es?mid=a10209000000',
				label: '창업진흥원 예비·초기·도약 등 사업 안내'
			}
		]
	},
	{
		path: '/guides/development-company-selection',
		kind: 'guide',
		title: '서울 외주 개발사 선택 · 앱·웹 업체 비교 기준',
		description:
			'개인사업자·스타트업·기업 담당자가 서울 앱·웹 외주 개발사를 비교할 때 확인할 실제 팀, 프로젝트 참여 범위, 견적·소통·유지보수 기준.',
		sections: [
			{
				title: '믿고 맡길 개발사는 어떤 근거로 비교하나요?',
				paragraphs: [
					'회사 소개 문구보다 실제 서비스의 운영 여부, 담당했던 역할, 함께 일할 사람과 완료 기준을 확인하세요. 로고가 있는 포트폴리오도 전체 개발인지 프론트엔드 참여인지 구분해야 판단에 도움이 됩니다.',
					'미스터디벨로는 서울 마포구 동교로 156-4 B1을 사업장 주소로 안내하고, 홈페이지에서 실제 팀과 업무 공간, 공개 프로젝트의 참여 범위를 소개합니다. 서울에서 대면 협의가 필요한 경우 일정과 참석 범위를 상담 때 확인해 주세요.'
				]
			},
			{
				title: '개인사업자·비개발 창업자가 먼저 물을 질문',
				paragraphs: [
					'“기획서가 없는데 어디부터 정리하나요?”, “첫 출시에서 꼭 필요한 기능은 무엇인가요?”, “관리자와 운영 비용도 견적에 포함되나요?”를 질문해 보세요. 만들고 싶은 이유, 사용자가 하는 행동과 현재의 대체 방법을 설명하면 기능 우선순위를 논의하기 쉽습니다.',
					'사업자 형태나 개발 지식의 유무보다 프로젝트의 목표, 예산·자료 준비와 의사결정 방식이 중요합니다. 미스터디벨로의 상담 준비 가이드와 MVP 안내에서 첫 상담에 필요한 항목을 확인할 수 있습니다.'
				]
			},
			{
				title: '스타트업과 기업 담당자가 비교할 역할',
				paragraphs: [
					'스타트업은 첫 검증 이후 고도화, 운영 계정과 소스 인수, 내부 팀 합류 가능성을 함께 살펴보세요. 기업 담당자는 기존 시스템 연동, 구매·보안 검토와 내부 승인 담당자, 납품 산출물과 검수 계획을 추가로 정리하면 좋습니다.',
					'전체를 맡기는 턴키 개발과 디자인·프론트엔드 등 일부 참여는 견적과 책임 범위가 다릅니다. 공개 사례에서 유사한 문제와 실제 담당 범위를 찾고 필요한 역할에 맞춰 비교하세요.'
				]
			},
			{
				title: '상담에서 확인할 다섯 가지 증거',
				paragraphs: [
					'1. 실제 서비스와 참여 범위. 2. 투입 역할과 소통 책임자. 3. 포함·제외 기능 및 추가 비용 조건. 4. 진행 공유와 검수 방법. 5. 소스·계정 인계와 유지보수 조건을 문서로 확인하세요.',
					'미스터디벨로의 공개 사례·프로세스·FAQ를 함께 읽고, 상담 결과가 실제 제안서와 계약에 어떻게 반영되는지 확인할 수 있습니다. 업체의 순위나 최저가 표현만으로 개발 적합성을 결정하기보다 검토 가능한 근거를 비교하는 것이 좋습니다.'
				]
			}
		],
		related: [
			{
				path: '/portfolio',
				label: '17개 공개 프로젝트와 참여 범위'
			},
			{
				path: '/intro/process',
				label: '미스터디벨로의 개발 진행 과정'
			},
			{
				path: '/guides/development-estimate',
				label: '같은 조건으로 견적 비교하기'
			},
			{
				path: '/services/si-development',
				label: '기업 SI 개발 안내'
			}
		]
	},
	{
		path: '/guides/enterprise-development-rfp',
		kind: 'guide',
		title: '기업 앱·웹·SI 개발 발주와 RFP 체크리스트',
		description:
			'중소·중견·대기업 담당자가 개발사에 제안 요청을 보낼 때 정리할 업무 목표, 요구사항, 연동·보안 조건, 검수와 운영 인수 항목.',
		sections: [
			{
				title: '기업 개발 제안 요청서에는 무엇이 필요하나요?',
				paragraphs: [
					'RFP(제안 요청서)는 업체가 동일한 목표와 조건으로 수행 범위를 검토하도록 돕는 문서입니다. 업무 배경, 현재 문제, 사용자와 운영자의 역할, 필수 기능, 기존 시스템·데이터와 희망 일정을 먼저 정리하세요.',
					'미스터디벨로에 기업 웹·앱·SI 개발을 문의할 때도 공개 가능한 요구사항과 내부 검토 절차를 알려주시면 참여 범위를 논의할 수 있습니다. 필수 자격·인증이나 NDA가 있다면 자료 공유 전에 확인해 주세요.'
				]
			},
			{
				title: '필수 기능과 제약 조건을 분리합니다',
				paragraphs: [
					'기능마다 입력, 처리, 결과와 오류 시 동작을 적고 사용자·관리자의 권한을 구분하세요. 연동할 시스템, 제공받을 API, 접속 환경과 데이터 이전 범위를 표시하면 업체가 가정한 범위의 차이를 줄일 수 있습니다.',
					'필수 보안 점검, 접근성 기준, 배포 승인 절차와 운영 시간 같은 제약은 발주처가 적용 기준을 명시해야 합니다. 구체적 확인 없이 모든 인증·보안 요구를 충족한다고 판단하지 마세요.'
				]
			},
			{
				title: '가격표와 함께 받아야 할 제안 내용',
				paragraphs: [
					'전체 금액뿐 아니라 기획·디자인·개발·QA의 포함 범위, 투입 역할, 전제 조건, 외부 비용과 제외 기능을 확인하세요. 담당 PM과 협의 창구, 보고 주기, 요구 변경의 승인 방식도 비교 항목에 넣으세요.',
					'유사 사례는 고객 이름과 실제 참여 역할을 함께 요청합니다. 미스터디벨로의 현대자동차그룹 리더십 플랫폼 사례는 프론트엔드 참여로 공개되어 있으므로 전체 시스템 구축 실적으로 넓혀 해석하지 않는 것이 정확합니다.'
				]
			},
			{
				title: '검수·인수·운영 전환을 착수 전에 합의합니다',
				paragraphs: [
					'요구사항과 테스트 항목을 연결하고, 누가 어떤 환경에서 검수할지 정합니다. 소스 코드, 디자인 원본, 배포 문서, 계정 소유권과 운영 이관 목록을 산출물로 명시하세요.',
					'운영 전환 중 문제가 생겼을 때의 연락 체계, 복구 절차, 오류 수정과 기능 추가의 구분을 확인합니다. 지원 기간·응답 시간·책임 범위는 프로젝트별 계약으로 정합니다.'
				]
			}
		],
		related: [
			{
				path: '/services/si-development',
				label: '기업 SI 시스템 구축 안내'
			},
			{
				path: '/portfolio/hyundai',
				label: '현대 HMG 참여 범위 확인'
			},
			{
				path: '/services/maintenance',
				label: '운영 인수와 유지보수'
			},
			{
				path: '/inquiry',
				label: '기업 프로젝트 제안 요청'
			}
		]
	}
];
